// import { LocationTrackingComponent } from './modules/assets/locationTracking/location-tracking/location-tracking.component';
import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { ErrorPageComponent } from './commonComponent/error-page/error-page.component';
import { EmailComponent } from './email/email.component';
import { permissionMatchGuard } from './permission.match.guard';
import { permissionGuard } from './permission.guard';
import { MONEY_CODE_MODULE_PERMISSIONS, MONEY_CODE_PERMISSIONS, REPORT_MODULE_PERMISSIONS, REPORT_PERMISSIONS } from '../constants/permissions';
import { Helpers } from './utils/helpers';
import { reportsLandingGuard } from './modules/reports/reports-landing.guard';
import { FloatingWindowComponent } from './commonComponent/floating-window/floating-window.component';

export const routes: Routes = [
  {
    path: 'auth',
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () => import('./modules/auth/login/login.component').then((c) => c.LoginComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./modules/auth/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent),
      },
    ],
  },

  {
    path: 'floating',
    component: FloatingWindowComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./commonComponent/floating-window/floating-host.component').then((c) => c.FloatingHostComponent),
      },
    ],
  },

  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('./home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'task-management',
        loadComponent: () => import('./modules/taskManagement/task-management-list/task-management-list.component').then((c) => c.TaskManagementListComponent),
      },
      {
        path: 'customer',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: ['CUS101', 'CUS102', 'CUS103', 'CUS104', 'CUS105', 'CUS106', 'CUS107', 'CUS108'],
        },
        children: [
          {
            path: '',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['CUS103'],
            },
            loadComponent: () => import('./modules/customer/customer-list/customer-list.component').then((c) => c.CustomerListComponent),
          },
          {
            path: 'add',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['CUS104'],
            },
            loadComponent: () => import('./modules/customer/customer-add/customer-add.component').then((c) => c.CustomerAddComponent),
          },
          {
            path: 'update/:id',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['CUS105'],
            },
            loadComponent: () => import('./modules/customer/customer-update/customer-update.component').then((c) => c.CustomerUpdateComponent),
          },
          {
            path: 'detail/:id',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['CUS103'],
            },
            loadComponent: () => import('./modules/customer/customer-detail/customer-detail.component').then((c) => c.CustomerDetailComponent),
          },
        ],
      },
      { path: 'email', component: EmailComponent },
      {
        path: 'user',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: ['USR103'],
        },
        loadComponent: () => import('./modules/userManagement/users/user-list/user-list.component').then((c) => c.UserListComponent),
      },
      {
        path: 'dispatch',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [
            'DIS101',
            'DIS102',
            'DIS103',
            'DIS104',
            'DIS105',
            'DIS106',
            'DIS107',
            'DIS108',
            'DIS109',
            'DIS113',
            'DIS114',
            'DIS115',
            'DIS116',
            'DIS117',
            'DIS119',
            'DIS120',
            'DIS121',
            'DIS122',
            'DIS123',
            'DIS124',
            'DIS129',
            'DIS130',
            'DIS131',
            'DIS132',
            'DIS125',
            'DIS126',
            'DIS127',
            'DIS128',
            'DIS133',
            'DIS135',
            'DIS136',
            'DIS137',
            'DIS138',
            'DIS139',
            'DIS140',
            'DIS141',
            'DIS142',
            'DIS143',
            'DIS145',
            'DIS146',
            'DIS147',
            'DIS148',
            'DIS149',
            'DIS150',
            'DIS151',
            'DIS152',
            'DIS153',
            'DIS154',
            'DIS155',
            'DIS156',
            'DIS157',
            'DIS158',
            'DIS159',
            'DIS160',
            'DIS163',
            'DIS164',
            'PLN103',
            'PLN105',
          ],
        },
        children: [
          {
            path: 'load-slip',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS136'],
            },
            loadComponent: () => import('./modules/dispatch/load/load-info-slip/load-info-slip.component').then((c) => c.LoadInfoSlipComponent),
          },
          {
            path: 'running',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS103'],
            },
            loadComponent: () => import('./modules/dispatch/running/running-list-v2/running-list-v2.component').then((m) => m.RunningListV2Component),
          },
          {
            path: 'running-v2',
            redirectTo: 'running',
            pathMatch: 'full',
          },
          {
            path: 'running/details/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS103'],
            },
            loadComponent: () => import('./modules/dispatch/running/dispatch-details/dispatch-details.component').then((c) => c.DispatchDetailsComponent),
          },
          {
            path: 'loads',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['DIS103'],
            },
            loadComponent: () => import('../app/modules/dispatch/load/load/load.component').then((m) => m.LoadComponent),
            children: [
              { path: '', redirectTo: 'running', pathMatch: 'full' },
              {
                path: 'running-v2',
                data: {
                  permissions: ['DIS103', 'DIS164', 'PLN103', 'PLN105'],
                },
                loadComponent: () => import('../app/modules/dispatch/load/runningV2/running-v2/running-v2.component').then((m) => m.RunningV2Component),
                children: [
                  { path: '', redirectTo: 'activeList-2', pathMatch: 'full' },
                  {
                    path: 'activeList',
                    data: {
                      permissions: ['DIS103'],
                    },
                    loadComponent: () => import('./modules/dispatch/load/runningV2/load-list-V2-backup/load-list-v2.component').then((m) => m.LoadListV2Component),
                  },
                  {
                    path: 'activeList-2',
                    data: {
                      permissions: ['DIS103'],
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/active-load-list/active-load-list.component').then((m) => m.ActiveLoadListComponent),
                  },
                  {
                    path: 'dropped',
                    data: {
                      permissions: ['DIS103'],
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/dropped-loads/dropped-loads.component').then((m) => m.DroppedLoadsComponent),
                  },
                  {
                    path: 'planning',
                    data: {
                      permissions: ['PLN103'],
                      view: 'board',
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/planning-2/planning-2.component').then((m) => m.Planning2Component),
                  },
                  {
                    path: 'driver-planning',
                    data: {
                      permissions: ['PLN103'],
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/driver-planning/driver-planning.component').then((m) => m.DriverPlanningComponent),
                  },
                  {
                    path: 'calendar',
                    data: {
                      permissions: ['PLN105'],
                      view: 'timeline',
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/planning-2/planning-2.component').then((m) => m.Planning2Component),
                  },
                  {
                    path: 'density-map',
                    data: {
                      permissions: ['ADMIN'],
                      view: 'map',
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/planning-2/planning-2.component').then((m) => m.Planning2Component),
                  },
                  {
                    path: 'consolidate',
                    data: {
                      permissions: ['DIS103'],
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/consolidate-list/consolidate-list.component').then((m) => m.ConsolidateListComponent),
                  },
                  {
                    path: 'consolidate-v2',
                    data: {
                      permissions: ['ADMIN'],
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/consolidate-board/consolidate-board.component').then((m) => m.ConsolidateBoardComponent),
                  },
                  {
                    path: 'trailer-board',
                    data: {
                      permissions: ['DIS164'],
                    },
                    loadComponent: () => import('../app/modules/dispatch/load/runningV2/trailer-board/trailer-board.component').then((m) => m.TrailerBoardComponent),
                  },
                  { path: 'planning-2', redirectTo: 'planning' },
                ],
              },
              {
                path: 'completed',
                canActivate: [permissionGuard],
                data: {
                  load_status: 'DELIVERED,TONU,CANCELLED',
                  permissions: ['DIS107', 'DIS109'],
                },
                loadComponent: () => import('../app/modules/dispatch/load/load-list-completed/load-list-completed.component').then((m) => m.LoadListCompletedComponent),
              },
              {
                path: 'cancelled',
                canActivate: [permissionGuard],
                data: {
                  permissions: ['DIS108'],
                },
                loadComponent: () => import('../app/modules/dispatch/load/load-list-cancelled/load-list-cancelled.component').then((m) => m.LoadListCancelledComponent),
              },
            ],
          },
          {
            path: 'load/add',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS104'],
            },
            loadComponent: () => import('./modules/dispatch/load/load-add/load-add.component').then((c) => c.LoadAddComponent),
          },
          {
            path: 'load/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS105'],
            },
            loadComponent: () => import('./modules/dispatch/load/load-update/load-update.component').then((c) => c.LoadUpdateComponent),
          },
          {
            path: 'load',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS103'],
            },
            loadComponent: () => import('./modules/dispatch/load/load-details/load-details.component').then((c) => c.LoadDetailsComponent),
          },
          {
            path: 'detention',
            canActivateChild: [permissionGuard],
            children: [
              {
                path: '',
                data: {
                  permissions: ['DIS115'],
                },
                loadComponent: () => import('./modules/dispatch/detention/detention-list/detention-list.component').then((c) => c.DetentionListComponent),
              },
            ],
          },
          {
            path: 'load-movements',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/dispatch/loadMovements/load-movements/load-movements.component').then((c) => c.LoadMovementsComponent),
            children: [
              { path: '', redirectTo: 'all-load-movements', pathMatch: 'full' },
              {
                path: 'all-load-movements',
                loadComponent: () => import('./modules/dispatch/loadMovements/all-load-movements/all-load-movements.component').then((c) => c.AllLoadMovementsComponent),
              },
              {
                path: 'by-trailer',
                loadComponent: () => import('./modules/dispatch/loadMovements/load-movements-by-trailer/load-movements-by-trailer.component').then((c) => c.LoadMovementsByTrailerComponent),
              },
              {
                path: 'by-load',
                loadComponent: () => import('./modules/dispatch/loadMovements/load-movements-by-load/load-movements-by-load.component').then((c) => c.LoadMovementsByLoadComponent),
              },
            ],
          },
          {
            path: 'trip',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['DIS120'],
            },
            loadComponent: () => import('./modules/dispatch/trip/trip-list/trip-list.component').then((c) => c.TripListComponent),
            children: [
              { path: '', redirectTo: 'open', pathMatch: 'full' },
              {
                path: 'all',
                data: {
                  status: 'ALL',
                  permissions: ['DIS120'],
                },
                loadComponent: () => import('./modules/dispatch/trip/trip-list-view/trip-list-view.component').then((c) => c.TripListViewComponent),
              },
              {
                path: 'open',
                data: {
                  status: 'OPENED',
                  permissions: ['DIS120'],
                },
                loadComponent: () => import('./modules/dispatch/trip/trip-list-view/trip-list-view.component').then((c) => c.TripListViewComponent),
              },
              {
                path: 'closed',
                canActivate: [permissionGuard],
                data: {
                  status: 'CLOSED',
                  permissions: ['DIS121'],
                },
                loadComponent: () => import('./modules/dispatch/trip/trip-list-view/trip-list-view.component').then((c) => c.TripListViewComponent),
              },
              {
                path: 'paid',
                data: {
                  permissions: ['DIS120'],
                },
                loadComponent: () => import('./modules/dispatch/trip/trip-paid/trip-paid.component').then((c) => c.TripPaidComponent),
              },
            ],
          },
          {
            path: 'reefer-reporting',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['DIS123'],
            },
            loadComponent: () => import('./modules/dispatch/reeferReporting/reefer-reporting/reefer-reporting.component').then((c) => c.ReeferReportingComponent),
            children: [
              { path: '', redirectTo: 'list', pathMatch: 'full' },
              {
                path: 'list',
                data: {
                  permissions: ['DIS123'],
                },
                loadComponent: () => import('./modules/dispatch/reeferReporting/reefer-reporting-list/reefer-reporting-list.component').then((c) => c.ReeferReportingListComponent),
              },
              // {
              //   path: 'old-list',
              //   data: {
              //     permissions: ['DIS123'],
              //   },
              //   loadComponent: () => import('./modules/dispatch/reeferReporting/old-reefer-reporting-list/old-reefer-reporting-list.component').then((c) => c.OldReeferReportingListComponent),
              // },
              {
                path: 'history',
                data: {
                  permissions: ['DIS123'],
                },
                loadComponent: () =>
                  import('./modules/dispatch/reeferReporting/reefer-reporting-history-list/reefer-reporting-history-list.component').then((c) => c.ReeferReportingHistoryListComponent),
              },
            ],
          },
          {
            path: 'load-templates',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS126'],
            },
            loadComponent: () => import('./modules/dispatch/loadTemplates/load-template-list/load-template-list.component').then((c) => c.LoadTemplateListComponent),
          },
          {
            path: 'load-templates-update',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DIS127'],
            },
            loadComponent: () => import('./modules/dispatch/loadTemplates/load-template-update/load-template-update.component').then((c) => c.LoadTemplateUpdateComponent),
          },
        ],
      },
      { path: 'planning', pathMatch: 'full', redirectTo: ({ queryParams }) => inject(Router).createUrlTree(['/dispatch/loads/running-v2/planning'], { queryParams }) },
      { path: 'planning-v2', pathMatch: 'full', redirectTo: ({ queryParams }) => inject(Router).createUrlTree(['/dispatch/loads/running-v2/planning'], { queryParams }) },
      {
        path: 'route-map',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: ['PLN103'],
        },
        children: [
          {
            path: '',
            data: {
              permissions: ['PLN103'],
            },
            loadComponent: () => import('./modules/dispatch/planning/route-map/route-map.component').then((c) => c.RouteMapComponent),
          },
        ],
      },
      { path: 'calendar', pathMatch: 'full', redirectTo: ({ queryParams }) => inject(Router).createUrlTree(['/dispatch/loads/running-v2/calendar'], { queryParams }) },
      {
        path: 'accounting',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [
            'ACC126',
            'ACC128',
            'ACC127',
            'ACC124',
            'ACC125',
            'ACC130',
            'ACC131',
            'ACC132',
            'ACC133',
            'ACC134',
            'ACC135',
            'ACC138',
            'ACC139',
            'ACC140',
            'ACC141',
            'ACC142',
            'ACC117',
            'ACC118',
            'ACC119',
            'ACC120',
            'ACC121',
            'ACC122',
            'ACC110',
            'ACC111',
            'ACC112',
            'ACC113',
            'ACC145',
          ],
        },
        children: [
          {
            path: 'chart-of-accounts',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['ACC110'],
            },
            loadComponent: () => import('./modules/accounting/chartOfAccounts/chartOfAccounts/chartOfAccounts.component').then((c) => c.ChartOfAccountsComponent),
            children: [
              { path: '', redirectTo: 'all', pathMatch: 'full' },
              {
                path: 'all',
                data: {
                  permissions: ['ACC110'],
                },
                loadComponent: () => import('./modules/accounting/chartOfAccounts/chart-of-accounts-list/chart-of-accounts-list.component').then((c) => c.ChartOfAccountsListComponent),
              },
              {
                path: 'freight-income',
                data: {
                  permissions: ['ACC110'],
                },
                loadComponent: () => import('./modules/accounting/chartOfAccounts/coa-freight-income-list/coa-freight-income-list.component').then((c) => c.CoaFreightIncomeListComponent),
              },
              {
                path: 'freight-expenses',
                data: {
                  permissions: ['ACC110'],
                },
                loadComponent: () => import('./modules/accounting/chartOfAccounts/coa-freight-expenses-list/coa-freight-expenses-list.component').then((c) => c.CoaFreightExpensesListComponent),
              },
              {
                path: 'freight-deductions',
                data: {
                  permissions: ['ACC110'],
                },
                loadComponent: () =>
                  import('./modules/accounting/chartOfAccounts/coa-freight-deductions-list/coa-freight-deductions-list.component').then((c) => c.CoaFreightDeductionsListComponent),
              },
              {
                path: 'freight-reimbursement',
                data: {
                  permissions: ['ACC110'],
                },
                loadComponent: () =>
                  import('./modules/accounting/chartOfAccounts/coa-freight-reimbursement-list/coa-freight-reimbursement-list.component').then((c) => c.CoaFreightReimbursementListComponent),
              },
              {
                path: 'driver-reimbursement',
                data: {
                  permissions: ['ACC110'],
                },
                loadComponent: () =>
                  import('./modules/accounting/chartOfAccounts/coa-driver-reimbursement-list/coa-driver-reimbursement-list.component').then((c) => c.CoaDriverReimbursementListComponent),
              },
              {
                path: 'load-expense-type',
                data: {
                  permissions: ['ACC110'],
                },
                loadComponent: () => import('./modules/accounting/chartOfAccounts/coa-load-expense-type-list/coa-load-expense-type-list.component').then((c) => c.CoaLoadExpenseTypeListComponent),
              },
            ],
          },

          {
            path: 'reports',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/accounting/reports/reports.component').then((c) => c.ReportsComponent),
          },
          {
            path: 'payments',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/accounting/payments/payments/payments.component').then((c) => c.PaymentsComponent),
            children: [
              { path: '', redirectTo: 'received-payments', pathMatch: 'full' },
              {
                path: 'received-payments',
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./modules/accounting/payments/receivedPayments/received-payments-list/received-payments-list.component').then((c) => c.ReceivedPaymentsListComponent),
              },
            ],
          },
          {
            path: 'transactions',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            children: [
              { path: '', redirectTo: 'list', pathMatch: 'full' },
              {
                path: 'list',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./modules/accounting/transactions/transaction-list/transaction-list.component').then((c) => c.TransactionListComponent),
              },
              {
                path: 'add',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./modules/accounting/transactions/transaction-add/transaction-add.component').then((c) => c.TransactionAddComponent),
                outlet: 'popup',
              },
            ],
          },
          {
            path: 'accounts-overview',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ACC145'],
            },
            loadComponent: () => import('./modules/accounting/accountsOverview/accounts-overview/accounts-overview.component').then((c) => c.AccountsOverviewComponent),
          },
          {
            path: 'account-transactions',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            children: [
              {
                path: '',
                redirectTo: 'account-transaction-list',
                pathMatch: 'full',
              },
              {
                path: 'account-transaction-list',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () =>
                  import('./modules/accounting/transactions/chart-account-transaction-list/chart-account-transaction-list.component').then((c) => c.ChartAccountTransactionListComponent),
              },
              {
                path: 'add',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./modules/accounting/transactions/transaction-add/transaction-add.component').then((c) => c.TransactionAddComponent),
                outlet: 'popup',
              },
            ],
          },
          {
            path: 'driver-settlements',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['ACC117'],
            },
            loadComponent: () => import('./modules/accounting/settlements/driverSettlements/driver-settlements/driver-settlements.component').then((c) => c.DriverSettlementsComponent),
            children: [
              { path: '', redirectTo: 'submission', pathMatch: 'full' },
              {
                path: 'settlements',
                data: {
                  permissions: ['ACC117'],
                  // reuse: true,
                },
                loadComponent: () => import('./modules/accounting/settlements/driverSettlements/settlements-list/settlements-list.component').then((c) => c.SettlementsListComponent),
                runGuardsAndResolvers: 'pathParamsChange',
                // data: { reuse: true },
              },
              {
                path: 'submission',
                loadComponent: () => import('./modules/accounting/settlements/driverSettlements/submission/submission-list/submission-list.component').then((c) => c.SubmissionListComponent),
              },
              {
                path: 'closed-trips',
                data: {
                  permissions: ['ACC117'],
                  // reuse: true,
                },
                loadComponent: () => import('./modules/accounting/settlements/driverSettlements/closed-trips/closed-trips.component').then((c) => c.ClosedTripsComponent),
              },
              {
                path: 'batches',
                data: {
                  permissions: ['ACC138'],
                },
                children: [
                  { path: '', redirectTo: 'list', pathMatch: 'full' },
                  {
                    path: 'list',
                    data: {
                      permissions: ['ACC138'],
                    },
                    loadComponent: () =>
                      import('./modules/accounting/settlements/driverSettlementBatch/driver-settlement-batch-list/driver-settlement-batch-list.component').then(
                        (c) => c.DriverSettlementBatchListComponent
                      ),
                  },
                  {
                    path: 'details',
                    canActivate: [permissionGuard],
                    data: {
                      permissions: ['ACC138'],
                    },
                    loadComponent: () =>
                      import('./modules/accounting/settlements/driverSettlementBatch/driver-settlement-batch-details/driver-settlement-batch-details.component').then(
                        (c) => c.DriverSettlementBatchDetailsComponent
                      ),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'billing',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [
            'ACC126',
            'ACC128',
            'ACC127',
            'ACC124',
            'ACC125',
            'ACC130',
            'ACC131',
            'ACC132',
            'ACC133',
            'ACC134',
            'ACC135',
            'ACC138',
            'ACC139',
            'ACC140',
            'ACC141',
            'ACC142',
            'ACC117',
            'ACC118',
            'ACC119',
            'ACC120',
            'ACC121',
            'ACC122',
            'ACC110',
            'ACC111',
            'ACC112',
            'ACC113',
          ],
        },
        children: [
          {
            path: 'ready-to-bill',
            loadComponent: () => import('./modules/billing/load-invoices/load-invoices.component').then((c) => c.LoadInvoicesComponent),
            children: [
              { path: '', redirectTo: 'list', pathMatch: 'full' },
              { path: 'list', loadComponent: () => import('./modules/billing/ready-to-bill/ready-to-bill.component').then((c) => c.ReadyToBillComponent) },
              {
                path: 'customer-rec-share',
                loadComponent: () => import('./modules/billing/customer-receivable-share/customer-receivable-share.component').then((c) => c.CustomerReceivableShareComponent),
              },
            ],
          },
          {
            path: 'batches',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['ACC124'],
            },
            loadComponent: () => import('./modules/billing/batches/batches.component').then((c) => c.BatchesComponent),
            children: [
              { path: '', redirectTo: 'list', pathMatch: 'full' },
              {
                path: 'list',
                data: {
                  permissions: ['ACC124'],
                },
                loadComponent: () => import('./modules/billing/batch-list/batch-list.component').then((c) => c.BatchListComponent),
              },
              {
                path: 'payments',
                loadComponent: () => import('./modules/billing/batchPayments/batch-payments-list/batch-payments-list.component').then((c) => c.BatchPaymentsListComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'money-code',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: MONEY_CODE_MODULE_PERMISSIONS,
        },
        children: [
          {
            path: 'providers',
            canActivate: [permissionGuard],
            data: {
              permissions: ['MNY103'],
            },
            loadComponent: () => import('./modules/moneyCode/providers/providers-list/providers-list.component').then((c) => c.ProvidersListComponent),
          },
          {
            path: '',
            canActivate: [permissionGuard],
            data: {
              permissions: MONEY_CODE_MODULE_PERMISSIONS,
            },
            loadComponent: () => import('./modules/moneyCode/moneyCode/money-code-tabs/money-code-tabs.component').then((c) => c.MoneyCodeTabsComponent),
            children: [
              {
                path: '',
                pathMatch: 'full',
                redirectTo: () => (inject(Helpers).handleCheckPermissions(MONEY_CODE_PERMISSIONS.view) ? 'list' : 'invoices'),
              },
              {
                path: 'list',
                canActivate: [permissionGuard],
                data: {
                  permissions: [MONEY_CODE_PERMISSIONS.view],
                },
                loadComponent: () => import('./modules/moneyCode/moneyCode/money-code-list/money-code-list.component').then((c) => c.MoneyCodeListComponent),
              },
              {
                path: 'invoices',
                canActivate: [permissionGuard],
                data: {
                  permissions: [MONEY_CODE_PERMISSIONS.invoiceView],
                },
                loadComponent: () => import('./modules/moneyCode/moneyCode/money-code-invoices/money-code-invoices.component').then((c) => c.MoneyCodeInvoicesComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'assets',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [
            'AST106',
            'AST117',
            'AST128',
            'AST103',
            'AST104',
            'AST105',
            'AST108',
            'AST109',
            'AST110',
            'AST111',
            'AST118',
            'AST129',
            'AST113',
            'AST114',
            'AST115',
            'AST116',
            'AST119',
            'AST130',
          ],
        },
        children: [
          {
            path: 'driver',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST103'],
            },
            loadComponent: () => import('./modules/assets/driver/driver-list/driver-list.component').then((c) => c.DriverListComponent),
            runGuardsAndResolvers: 'paramsOrQueryParamsChange',
          },

          {
            path: 'driver/add',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST104'],
            },
            loadComponent: () => import('./modules/assets/driver/driver-add/driver-add.component').then((c) => c.DriverAddComponent),
          },
          {
            path: 'driver/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST105'],
            },
            loadComponent: () => import('./modules/assets/driver/driver-update/driver-update.component').then((c) => c.DriverUpdateComponent),
          },
          {
            path: 'driver/detail/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST103'],
            },
            loadComponent: () => import('./modules/assets/driver/driver-detail/driver-detail.component').then((c) => c.DriverDetailComponent),
          },
          {
            path: 'driver-offs',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DRV103'],
            },
            loadComponent: () => import('./modules/assets/driverOff/driver-off-list/driver-off-list.component').then((c) => c.DriverOffListComponent),
          },
          {
            path: 'driver-requests',
            canActivate: [permissionGuard],
            data: {
              permissions: ['DRV103'],
            },
            loadComponent: () => import('./modules/assets/driverRequest/driver-request-list/driver-request-list.component').then((c) => c.DriverRequestListComponent),
          },

          {
            path: 'truck',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST108'],
            },
            loadComponent: () => import('./modules/assets/truck/truck-list/truck-list.component').then((c) => c.TruckListComponent),
          },
          {
            path: 'truck/add',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST109'],
            },
            loadComponent: () => import('./modules/assets/truck/truck-add/truck-add.component').then((c) => c.TruckAddComponent),
          },
          {
            path: 'truck/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST110'],
            },
            loadComponent: () => import('./modules/assets/truck/truck-update/truck-update.component').then((c) => c.TruckUpdateComponent),
          },
          {
            path: 'truck/detail/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST108'],
            },
            loadComponent: () => import('./modules/assets/truck/truck-detail/truck-detail.component').then((c) => c.TruckDetailComponent),
          },

          {
            path: 'trailer',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST113'],
            },
            loadComponent: () => import('./modules/assets/trailer/trailer-list/trailer-list.component').then((c) => c.TrailerListComponent),
          },
          {
            path: 'trailer/add',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST114'],
            },
            loadComponent: () => import('./modules/assets/trailer/trailer-add/trailer-add.component').then((c) => c.TrailerAddComponent),
          },
          {
            path: 'trailer/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST115'],
            },
            loadComponent: () => import('./modules/assets/trailer/trailer-update/trailer-update.component').then((c) => c.TrailerUpdateComponent),
          },
          {
            path: 'trailer/detail/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['AST113'],
            },
            loadComponent: () => import('./modules/assets/trailer/trailer-detail/trailer-detail.component').then((c) => c.TrailerDetailComponent),
          },
          {
            path: 'continuity',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/assetContinuity/asset-continuity/asset-continuity.component').then((c) => c.AssetContinuityComponent),
            children: [
              { path: '', redirectTo: 'asset-wise-list', pathMatch: 'full' },
              // {
              //   path: 'asset-wise-list',
              //   redirectTo: 'asset-wise-continuity',
              //   pathMatch: 'full',
              // },
              {
                path: 'asset-wise-list',
                loadComponent: () => import('./modules/assets/assetContinuity/asset-wise-list/asset-wise-list.component').then((c) => c.AssetWiseListComponent),
              },
              {
                path: 'asset-continuity-v2',
                loadComponent: () =>
                  import('./modules/assets/assetContinuity/asset-continuity-v2/asset-continuity-v2.component').then((c) => c.AssetContinuityV2Component),
              },
              { path: 'asset-continuity-v3', redirectTo: 'asset-continuity-v2', pathMatch: 'full' },
              {
                path: 'open-bypasses',
                loadComponent: () => import('./modules/assets/assetContinuity/open-bypasses/open-bypasses.component').then((c) => c.OpenBypassesComponent),
              },
              {
                path: 'continuity-break-count',
                loadComponent: () => import('./modules/assets/assetContinuity/asset-wise-count/asset-wise-count.component').then((c) => c.AssetWiseCountComponent),
              },
              {
                path: 'dirty-continuity-list',
                loadComponent: () => import('./modules/assets/assetContinuity/dirty-continuity-list/dirty-continuity-list.component').then((c) => c.DirtyContinuityListComponent),
              },
              {
                path: 'bypassed-wise-count',
                loadComponent: () => import('./modules/assets/assetContinuity/bypassed-wise-count/bypassed-wise-count.component').then((c) => c.BypassedWiseCountComponent),
              },
            ],
          },
          {
            path: 'companies',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            children: [
              {
                path: '',
                loadComponent: () => import('./modules/assets/companies/companies-list/companies-list.component').then((c) => c.CompaniesListComponent),
              },
            ],
          },
          {
            path: 'location-tracking',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/locationTracking/location-tracking/location-tracking.component').then((c) => c.LocationTrackingComponent),
          },
          {
            path: 'documents',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/document-list/document-list.component').then((c) => c.DocumentListComponent),
          },
          {
            path: 'compliance-records',
            canActivateChild: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/assets/complianceRecords/compliance-records/compliance-records.component').then((c) => c.ComplianceRecordsComponent),
            children: [
              { path: '', redirectTo: 'driver', pathMatch: 'full' },
              {
                path: 'driver',
                data: { kind: 'DRIVER' },
                loadComponent: () => import('./modules/assets/complianceRecords/compliance-record-list/compliance-record-list.component').then((c) => c.ComplianceRecordListComponent),
              },
              {
                path: 'truck',
                data: { kind: 'TRUCK' },
                loadComponent: () => import('./modules/assets/complianceRecords/compliance-record-list/compliance-record-list.component').then((c) => c.ComplianceRecordListComponent),
              },
              {
                path: 'trailer',
                data: { kind: 'TRAILER' },
                loadComponent: () => import('./modules/assets/complianceRecords/compliance-record-list/compliance-record-list.component').then((c) => c.ComplianceRecordListComponent),
              },
            ],
          },
          {
            path: 'asset-makers',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/vehicleMakers/vehicle-makers-list/vehicle-makers-list.component').then((c) => c.VehicleMakersListComponent),
          },
          {
            path: 'asset-makers/add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/vehicleMakers/vehicle-makers-add/vehicle-makers-add.component').then((c) => c.VehicleMakersAddComponent),
          },
          {
            path: 'asset-makers/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/vehicleMakers/vehicle-makers-update/vehicle-makers-update.component').then((c) => c.VehicleMakersUpdateComponent),
          },
          {
            path: 'asset-models',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/vehicleModels/vehicle-models-list/vehicle-models-list.component').then((c) => c.VehicleModelsListComponent),
          },
          {
            path: 'asset-models/add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/vehicleModels/vehicle-models-add/vehicle-models-add.component').then((c) => c.VehicleModelsAddComponent),
          },
          {
            path: 'asset-models/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/assets/vehicleModels/vehicle-models-update/vehicle-models-update.component').then((c) => c.VehicleModelsUpdateComponent),
          },
        ],
      },

      {
        path: 'locations',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: ['LOC101', 'LOC122', 'LOC123', 'LOC124', 'LOC125'],
        },
        children: [
          {
            path: 'address-book',
            canActivate: [permissionGuard],
            data: {
              permissions: ['LOC123'],
            },
            loadComponent: () => import('./modules/locations/address/address-list/address-list.component').then((c) => c.AddressListComponent),
          },
          {
            path: 'address-book/add',
            canActivate: [permissionGuard],
            data: {
              permissions: ['LOC124'],
            },
            loadComponent: () => import('./modules/locations/address/address-add/address-add.component').then((c) => c.AddressAddComponent),
          },
          {
            path: 'address-book/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['LOC125'],
            },
            loadComponent: () => import('./modules/locations/address/address-update/address-update.component').then((c) => c.AddressUpdateComponent),
          },
          {
            path: 'address-book/detail/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: ['LOC123'],
            },
            loadComponent: () => import('./modules/locations/address/address-detail/address-detail.component').then((c) => c.AddressDetailComponent),
          },

          {
            path: 'distance',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/distance/distance-list/distance-list.component').then((c) => c.DistanceListComponent),
          },

          {
            path: 'country',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/country/country-list/country-list.component').then((c) => c.CountryListComponent),
          },
          {
            path: 'country/add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/country/country-add/country-add.component').then((c) => c.CountryAddComponent),
          },
          {
            path: 'country/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/country/country-update/country-update.component').then((c) => c.CountryUpdateComponent),
          },

          {
            path: 'state',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/state/state-list/state-list.component').then((c) => c.StateListComponent),
          },
          {
            path: 'state/add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/state/state-add/state-add.component').then((c) => c.StateAddComponent),
          },
          {
            path: 'state/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/state/state-update/state-update.component').then((c) => c.StateUpdateComponent),
          },

          {
            path: 'city',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/city/city-list/city-list.component').then((c) => c.CityListComponent),
          },
          {
            path: 'city/add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/city/city-add/city-add.component').then((c) => c.CityAddComponent),
          },
          {
            path: 'city/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/city/city-update/city-update.component').then((c) => c.CityUpdateComponent),
          },

          {
            path: 'zipcode',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/zipcode/zipcode-list/zipcode-list.component').then((c) => c.ZipcodeListComponent),
          },
          {
            path: 'zipcode/add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/zipcode/zipcode-add/zipcode-add.component').then((c) => c.ZipcodeAddComponent),
          },
          {
            path: 'zipcode/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/locations/zipcode/zipcode-update/zipcode-update.component').then((c) => c.ZipcodeUpdateComponent),
          },
        ],
      },

      {
        path: 'reports',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: REPORT_MODULE_PERMISSIONS,
        },
        loadComponent: () => import('./modules/reports/reports/reports.component').then((c) => c.ReportsComponent),
        children: [
          { path: '', pathMatch: 'full', canActivate: [reportsLandingGuard], children: [] },

          {
            path: 'driver-report',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.driverReport],
            },
            loadComponent: () => import('./modules/reports/assets/driver-report-list/driver-report-list.component').then((c) => c.DriverReportListComponent),
          },
          {
            path: 'truck-report',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.truckReport],
            },
            loadComponent: () => import('./modules/reports/assets/truck-report-list/truck-report-list.component').then((c) => c.TruckReportListComponent),
          },
          {
            path: 'trailer-report',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.trailerReport],
            },
            loadComponent: () => import('./modules/reports/assets/trailer-report-list/trailer-report-list.component').then((c) => c.TrailerReportListComponent),
          },
          {
            path: 'daily-metrics',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.dailyMetricsList],
            },
            children: [
              {
                path: '',
                loadComponent: () => import('./modules/reports/dailyMetrics/daily-metrics-list/daily-metrics-list.component').then((c) => c.DailyMetricsListComponent),
              },
            ],
          },
          {
            path: 'daily-driver-hos',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.driverHosList],
            },
            loadComponent: () => import('./modules/reports/daily-driver-hos-clock/daily-driver-hos-clock.component').then((c) => c.DailyDriverHosClockComponent),
          },
          {
            path: 'dispatcher-score-card',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.dispatcherScoreCard],
            },
            loadComponent: () => import('./modules/reports/dispatcherPerformance/dispatcher-performance-list/dispatcher-performance-list.component').then((c) => c.DispatcherPerformanceListComponent),
          },
          {
            path: 'customer-revenue',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.customerRevenueList],
            },
            loadComponent: () => import('./modules/reports/customerRevenue/customer-revenue-list/customer-revenue-list.component').then((c) => c.CustomerRevenueListComponent),
          },
          {
            path: 'truck-logs',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.truckLogsList],
            },
            loadComponent: () => import('./modules/reports/truckLogs/truck-logs-list/truck-logs-list.component').then((c) => c.TruckLogsListComponent),
          },
          {
            path: 'asset-revenue',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.assetRevenueList],
            },
            loadComponent: () => import('./modules/reports/assets/asset-revenue-list/asset-revenue-list.component').then((c) => c.AssetRevenueListComponent),
          },
          {
            path: 'asset-revenue-2',
            canActivate: [permissionGuard],
            data: {
              permissions: [REPORT_PERMISSIONS.assetRevenueList],
            },
            loadComponent: () => import('./modules/reports/assets/asset-revenue-2-list/asset-revenue-2-list.component').then((c) => c.AssetRevenue2ListComponent),
          },
        ],
      },
      {
        path: 'background-audits',
        loadComponent: () => import('./modules/backgroundAudit/background-audit/background-audit.component').then((c) => c.BackgroundAuditComponent),
        children: [
          { path: '', redirectTo: 'dispatch-list-without-trips', pathMatch: 'full' },

          {
            path: 'dispatch-list-without-trips',
            loadComponent: () => import('./modules/backgroundAudit/dispatches-without-trips/dispatches-without-trips.component').then((c) => c.DispatchesWithoutTripsComponent),
          },
          {
            path: 'dispatch-list-with-trips',
            loadComponent: () => import('./modules/backgroundAudit/dispatches-with-trips/dispatches-with-trips.component').then((c) => c.DispatchesWithTripsComponent),
          },

          {
            path: 'dispatches-without-payrates',
            loadComponent: () => import('./modules/backgroundAudit/dispatches-without-payrates/dispatches-without-payrates.component').then((c) => c.DispatchesWithoutPayratesComponent),
          },
        ],
      },
      {
        path: 'background-process',
        loadComponent: () => import('./modules/backgroundProcess/background-process/background-process.component').then((c) => c.BackgroundProcessComponent),
        children: [
          { path: '', redirectTo: 'schedule', pathMatch: 'full' },
          {
            path: 'schedule',
            loadComponent: () => import('./modules/backgroundProcess/schedule/schedule.component').then((c) => c.ScheduleComponent),
          },
          {
            path: 'schedule/history/:id',
            loadComponent: () => import('./modules/backgroundProcess/schedule/schedule.component').then((c) => c.ScheduleComponent),
          },
          {
            path: 'redis-stats',
            loadComponent: () => import('./modules/backgroundProcess/redis-stats/redis-stats.component').then((c) => c.RedisStatsComponent),
            children: [
              { path: '', redirectTo: 'memory-usage', pathMatch: 'full' },
              {
                path: 'memory-usage',
                loadComponent: () => import('./modules/backgroundProcess/redis-stats/memory-usage/memory-usage.component').then((c) => c.MemoryUsageComponent),
              },
              {
                path: 'job-queues',
                loadComponent: () => import('./modules/backgroundProcess/redis-stats/job-queues/job-queues.component').then((c) => c.JobQueuesComponent),
              },
            ],
          },
          {
            path: 'outbox-events',
            loadComponent: () => import('./modules/backgroundProcess/outbox-events/outbox-events.component').then((c) => c.OutboxEventsComponent),
          },
        ],
      },

      {
        path: 'settings',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [],
        },
        loadComponent: () => import('./settings/settings/settings.component').then((c) => c.SettingsComponent),
        children: [
          { path: '', redirectTo: 'change-password', pathMatch: 'full' },
          {
            path: 'general-settings',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/general-settings/general-settings.component').then((c) => c.GeneralSettingsComponent),
          },
          {
            path: 'communication',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/communication/communication/communication.component').then((c) => c.CommunicationComponent),
            children: [
              { path: '', redirectTo: 'email-sender', pathMatch: 'full' },
              {
                path: 'email-templates',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/communication/emailTemplate/email-template-list/email-template-list.component').then((c) => c.EmailTemplateListComponent),
              },
              {
                path: 'email-sender',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/communication/emailSender/email-sender-list/email-sender-list.component').then((c) => c.EmailSenderListComponent),
              },
              {
                path: 'email-server',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/communication/emailServer/email-server-list/email-server-list.component').then((c) => c.EmailServerListComponent),
              },
            ],
          },
          {
            path: 'driver-pay-rate',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/driver-pay-rate-group/driver-pay-rate-group-list/driver-pay-rate-group-list.component').then((c) => c.DriverPayRateGroupListComponent),
          },

          {
            path: 'load-blocker-type',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/dispatch/load/loadBlockerTypes/load-blocker-types-list/load-blocker-types-list.component').then((c) => c.LoadBlockerTypesListComponent),
          },

          {
            path: 'empty-miles-type',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/emptyMilesType/empty-miles-type-list/empty-miles-type-list.component').then((c) => c.EmptyMilesTypeListComponent),
          },

          {
            path: 'terminal',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./settings/terminal/terminal-list/terminal-list.component').then((c) => c.TerminalListComponent),
          },

          {
            path: 'user-management',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/userManagement/user-management/user-management.component').then((c) => c.UserManagementComponent),
            children: [
              { path: '', redirectTo: 'users', pathMatch: 'full' },
              {
                path: 'users',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./modules/userManagement/users/user-list/user-list.component').then((c) => c.UserListComponent),
              },
              {
                path: 'roles',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./modules/userManagement/roles/role-list/role-list.component').then((c) => c.RoleListComponent),
              },
            ],
          },

          {
            path: 'change-password',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/change-password/change-password.component').then((c) => c.ChangePasswordComponent),
          },

          {
            path: 'document-type',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/documentType/document-type-list/document-type-list.component').then((c) => c.DocumentTypeListComponent),
          },
          {
            path: 'document/add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/documentType/document-type-add/document-type-add.component').then((c) => c.DocumentTypeAddComponent),
          },
          {
            path: 'document/update/:id',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/documentType/document-type-update/document-type-update.component').then((c) => c.DocumentTypeUpdateComponent),
          },
          {
            path: 'options',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/options/options/options.component').then((c) => c.OptionsComponent),
            children: [
              { path: '', redirectTo: 'load-special-requirement', pathMatch: 'full' },
              {
                path: 'load-special-requirement',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () =>
                  import('./settings/options/loadSpecialRequirement/load-special-requirement-list/load-special-requirement-list.component').then((c) => c.LoadSpecialRequirementListComponent),
              },
              {
                path: 'load-special-requirement/add',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () =>
                  import('./settings/options/loadSpecialRequirement/load-special-requirement-add/load-special-requirement-add.component').then((c) => c.LoadSpecialRequirementAddComponent),
              },
              {
                path: 'load-special-requirement/update/:id',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () =>
                  import('./settings/options/loadSpecialRequirement/load-special-requirement-update/load-special-requirement-update.component').then((c) => c.LoadSpecialRequirementUpdateComponent),
              },
            ],
          },

          {
            path: 'payment-methods',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/paymentMethods/payment-method-list/payment-method-list.component').then((c) => c.PaymentMethodListComponent),
          },
          {
            path: 'accounting',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/factoring/factoring/factoring.component').then((c) => c.FactoringComponent),
            children: [
              { path: '', redirectTo: 'factoring', pathMatch: 'full' },
              {
                path: 'factoring',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/factoring/factoring-list/factoring-list.component').then((c) => c.FactoringListComponent),
              },
            ],
          },
          {
            path: 'integration',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/integration/integration/integration.component').then((c) => c.IntegrationComponent),
            children: [
              { path: '', redirectTo: 'samsara', pathMatch: 'full' },
              {
                path: 'samsara',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/integration/samsara/samsara.component').then((c) => c.SamsaraComponent),
              },
              {
                path: 'one',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                  provider: 'ONE',
                },
                loadComponent: () => import('./settings/integration/fleet-integration/fleet-integration.component').then((c) => c.FleetIntegrationComponent),
              },
              {
                path: 'books',
                canActivate: [permissionGuard],
                data: { permissions: ['ADMIN'] },
                loadComponent: () => import('./settings/integration/books-integration/books-integration.component').then((c) => c.BooksIntegrationComponent),
              },
              {
                path: 'compliance',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                  provider: 'COMPLIANCE',
                },
                loadComponent: () => import('./settings/integration/fleet-integration/fleet-integration.component').then((c) => c.FleetIntegrationComponent),
              },
            ],
          },
          {
            path: 'teams',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            children: [
              {
                path: '',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/teams/teams-list/teams-list.component').then((c) => c.TeamsListComponent),
              },
            ],
          },
          {
            path: 'checklist',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/checklist/checklist/checklist.component').then((e) => e.ChecklistComponent),
            children: [
              { path: '', redirectTo: 'on-pickup-checkout', pathMatch: 'full' },
              {
                path: 'on-pickup-checkout',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/checklist/checklist-on-pickup-checkout/checklist-on-pickup-checkout.component').then((e) => e.ChecklistOnPickupCheckoutComponent),
              },
              {
                path: 'on-delivery-checkout',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/checklist/checklist-on-delivery-checkout/checklist-on-delivery-checkout.component').then((e) => e.ChecklistOnDeliveryCheckoutComponent),
              },
              {
                path: 'on-trailer-drop',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/checklist/checklist-on-trailer-drop/checklist-on-trailer-drop.component').then((e) => e.ChecklistOnTrailerDropComponent),
              },
              {
                path: 'on-load-create',
                loadComponent: () => import('./settings/checklist/checklist-on-load-create/checklist-on-load-create.component').then((e) => e.ChecklistOnLoadCreateComponent),
              },
            ],
          },
          {
            path: 'task-recurrence',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            children: [
              {
                path: '',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/taskRecurrence/task-recurrence-list/task-recurrence-list.component').then((c) => c.TaskRecurrenceListComponent),
              },
            ],
          },

          {
            path: 'labels',
            loadComponent: () => import('./settings/labels/label-list/label-list.component').then((c) => c.LabelListComponent),
          },
          {
            path: 'reasons',
            canActivateChild: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./settings/reasons/reasons/reasons.component').then((c) => c.ReasonsComponent),
            children: [
              { path: '', pathMatch: 'full', children: [] },
              {
                path: ':object',
                canActivate: [permissionGuard],
                data: {
                  permissions: [],
                },
                loadComponent: () => import('./settings/reasons/reason-list/reason-list.component').then((c) => c.ReasonListComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'vendors',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [],
        },
        children: [
          {
            path: '',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/vendors/vendors-list/vendors-list.component').then((c) => c.VendorsListComponent),
          },
          {
            path: 'add',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/vendors/vendors-add/vendors-add.component').then((c) => c.VendorsAddComponent),
          },
        ],
      },
      {
        path: 'maintenance',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [],
        },
        children: [
          // { path: 'list', loadComponent: () => import('./modules/maintenance/maintenance-list/maintenance-list.component').then(c => c.MaintenanceListComponent), },
          {
            path: '',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/maintenance/maintenance-truck-list/maintenance-truck-list.component').then((c) => c.MaintenanceTruckListComponent),
          },
          {
            path: 'trailer',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/maintenance/maintenance-trailer-list/maintenance-trailer-list.component').then((c) => c.MaintenanceTrailerListComponent),
          },
          {
            path: 'tracking',
            canMatch: [permissionMatchGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/maintenance/maintenance-tracking/maintenance-tracking-list/maintenance-tracking-list.component').then((c) => c.MaintenanceTrackingListComponent),
          },
          {
            path: 'types',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/maintenance/maintenance-types/maintenance-types-list/maintenance-types-list.component').then((c) => c.MaintenanceTypesListComponent),
          },
          {
            path: 'work-order',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/maintenance/workOrder/work-order-list/work-order-list.component').then((c) => c.WorkOrderListComponent),
          },
        ],
      },
      {
        path: 'customer-microservice',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [],
        },
        children: [
          {
            path: '',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/customer-microservice/customer-microservice-list/customer-microservice-list.component').then((c) => c.CustomerMicroserviceListComponent),
          },
        ],
      },
      {
        path: 'sessions',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [],
        },
        children: [
          {
            path: '',
            canActivate: [permissionGuard],
            data: {
              permissions: [],
            },
            loadComponent: () => import('./modules/sessions/sessions-list/sessions-list.component').then((c) => c.SessionsListComponent),
          },
        ],
      },
      {
        path: 'development',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: ['ADMIN'],
        },
        children: [
          {
            path: 'content',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/development/development/development.component').then((c) => c.DevelopmentComponent),
            children: [
              {
                path: '',
                redirectTo: 'general',
                pathMatch: 'full',
              },
              {
                path: ':slug',
                canActivate: [permissionGuard],
                data: {
                  permissions: ['ADMIN'],
                },
                loadComponent: () => import('./modules/development/development-renderer/development-renderer.component').then((c) => c.DevelopmentRendererComponent),
              },
            ],
          },
          // {
          //   path: 'content/:slug',
          //   canActivate: [permissionGuard],
          //   data: {
          //     permissions: ['ADMIN'],
          //   },
          //   loadComponent: () => import('./modules/development/development-renderer/development-renderer.component').then((c) => c.DevelopmentRendererComponent),
          // },
          {
            path: 'temp-get-all-incomes-expenses-of-loads',
            pathMatch: 'full',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/development/load-income-expense-list/load-income-expense-list.component').then((c) => c.LoadIncomeExpenseListComponent),
          },
          {
            path: 'file-chunks-upload',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/development/file-chunks-upload/file-chunks-upload.component').then((c) => c.FileChunksUploadComponent),
          },
          {
            path: 'buttons-gallery',
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/development/buttons-gallery/buttons-gallery.component').then((c) => c.ButtonsGalleryComponent),
          },
          {
            path: 'not-linked-to-stop-expenses-and-load',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () =>
              import('./modules/development/not-linked-to-stop-expenses-and-load/not-linked-to-stop-expenses-and-load.component').then((c) => c.NotLinkedToStopExpensesAndLoadComponent),
          },
          {
            path: 'backfills',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/development/backfill-list/backfill-list.component').then((c) => c.BackfillListComponent),
          },
          {
            path: 'broker-link',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/development/broker-link/broker-link.component').then((c) => c.BrokerLinkComponent),
          },
          {
            path: 'broker-directory-stub',
            canActivate: [permissionGuard],
            data: {
              permissions: ['ADMIN'],
            },
            loadComponent: () => import('./modules/development/broker-directory-stub/broker-directory-stub.component').then((c) => c.BrokerDirectoryStubComponent),
          },
        ],
      },
      {
        path: 'task-quick-search',
        canMatch: [permissionMatchGuard],
        data: {
          permissions: [],
        },
        loadComponent: () => import('./modules/taskQuickSearch/task-quick-search/task-quick-search.component').then((c) => c.TaskQuickSearchComponent),
      },
    ],
  },

  { path: '**', component: ErrorPageComponent },
];

// export const floatingRoutes: Routes = [
//   {
//     path: 'floating',
//     loadComponent: () =>
//       import(
//         './modules/taskQuickSearch/task-quick-search/task-quick-search.component'
//       ).then((c) => c.TaskQuickSearchComponent),
//   },
// ];
